import styles from "../../_styles/InfoBlock.module.scss";
import { infoBlockItems } from "../../../../constants/structure";
import InfoBlockIcons from "./InfoBlockIcons";
import React from "react";
import { useTranslation } from "react-i18next";
import { setCountFeed } from "../../../../store/slices/feed.slice";
import { useDispatch } from "react-redux";
import { setLoginModal } from "../../../../store/slices/modals.slice";
import { formatLikeCount } from "../../../../utils/helpers";

interface IProps {
  isMobile?: boolean;
  likeHandler: (e: any, item: any, flag: boolean) => void;
  favouritesHandler: (e: any, item: any, flag: boolean) => void;
  reviewHandler: () => void;
  liked: boolean;
  inFavourites: boolean;
  shared: boolean;
  item: any;
  shareHandler: () => void;
  className?: string;
  classNameWrapper?: string;
  classNameItem?: string;
  updateFieldLocal?: (field: string, type: any) => void;
}

const ChooseInfoBlock = ({
  isMobile,
  likeHandler,
  reviewHandler,
  favouritesHandler,
  liked,
  shared,
  inFavourites,
  item,
  shareHandler,
  classNameWrapper,
  classNameItem,
  updateFieldLocal,
}: IProps) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const valueHandler = (path: string, def: any) => {
    if (path === "likes") {
      return formatLikeCount(item?.vote_count);
    }
    if (path === "secondaryShare") {
      return item?.shares_count;
    }

    if (path === "saved") {
      return item?.favorites_count;
    }

    return def;
  };

  const updateLocalCount = (id: any, key: any, type: any) => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    dispatch(setCountFeed({ id, key, type }));
  };

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div className={`${isMobile ? styles.itemInfoBarMobile : styles.itemInfoBar} ${classNameWrapper ?? ""}`}>
      {infoBlockItems.map((infoBlockItem, index) => {
        return (
          <div
            id={infoBlockItem.path}
            key={infoBlockItem.path}
            onClick={(e) => {
              const token = localStorage.getItem("accessToken");

              if (infoBlockItem.handler === "like") {
                if (!token) {
                  dispatch(setLoginModal(true));
                  return;
                }

                updateLocalCount(item.id, "vote_count", liked ? "decrement" : "increment");
                updateFieldLocal?.("vote_count", liked ? "decrement" : "increment");
                return likeHandler(e, item, liked);
              }

              if (infoBlockItem.handler === "saved") {
                if (!token) {
                  dispatch(setLoginModal(true));
                  return;
                }

                updateLocalCount(item.id, "favorites_count", inFavourites ? "decrement" : "increment");
                updateFieldLocal?.("favorites_count", inFavourites ? "decrement" : "increment");
                return favouritesHandler(e, item, inFavourites);
              }

              if (infoBlockItem.handler === "share") {
                return shareHandler();
              }
            }}
            className={`${styles.infoBarItemWrapper} ${isMobile ? styles.infoBarItemWrapperMobile : ""} ${classNameItem ?? ""}`}
          >
            <div className={styles.infoBarContentWrapper}>
              <InfoBlockIcons
                dir={dirData}
                isMobile={isMobile}
                iconName={infoBlockItem.path}
                liked={liked}
                shared={shared}
                inFavourites={inFavourites}
              />
              <div>{valueHandler(infoBlockItem.path, infoBlockItem.number)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ChooseInfoBlock;
